import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { Box } from 'lucide-react';
import { defaultStyle } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const PlainFullScreenLoader = ({
  message,
  children,
}: {
  message: string;
  children?: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 1000,
        textAlign: 'center',
        px: 2,
      }}
    >
      <CircularProgress />
      {message && (
        <Typography variant="h6" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default PlainFullScreenLoader;
